import { render, staticRenderFns } from "./ParticaCardMid.vue?vue&type=template&id=68ed6d60&scoped=true&"
import script from "./ParticaCardMid.vue?vue&type=script&lang=ts&"
export * from "./ParticaCardMid.vue?vue&type=script&lang=ts&"
import style0 from "./ParticaCardMid.vue?vue&type=style&index=0&id=68ed6d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ed6d60",
  null
  
)

export default component.exports